import React, { useRef } from 'react';

export const IconCaretDownFill = ({ ...props }) => {
  return <img src="/assets/icons/caret-down-fill.svg" {...props} />;
};

export const IconCaretRightFill = ({ ...props }) => {
  return <img src="/assets/icons/caret-right-fill.svg" {...props} />;
};

export const IconArrowRightCircle = ({ ...props }) => {
  return <img src="/assets/icons/arrow-right-circle.svg" {...props} />;
};

export const IconPencilSquare = ({ ...props }) => {
  return <img src="/assets/icons/pencil-square.svg" {...props} />;
};

export const IconPlusCircle = ({ ...props }) => {
  return <img src="/assets/icons/plus-circle.svg" {...props} />;
};

export const IconFileX = ({ ...props }) => {
  return <img src="/assets/icons/file-x.svg" {...props} />;
};
export const IconExclamation = ({ ...props }) => {
  return <img src="/assets/icons/exclamation.svg" {...props} />;
};
export const IconCheckSquare = ({ ...props }) => {
  return <img src="/assets/icons/check-square.svg" {...props} />;
};
export const IconSquare = ({ ...props }) => {
  return <img src="/assets/icons/square.svg" {...props} />;
};

export const IconChevronRight = ({ ...props }) => {
  return <img src="/assets/icons/chevron-right.svg" {...props} />;
};

export const IconExclamationCircleFill = ({ ...props }) => {
  return <img src="/assets/icons/exclamation-circle-fill.svg" {...props} />;
};

export const IconCheck = ({ ...props }) => {
  return <img src="/assets/icons/check.svg" {...props} />;
};

export const IconDice1 = ({ ...props }) => {
  return <img src="/assets/icons/dice-1.svg" {...props} />;
};
export const IconExclamationTriangleFillRed = ({ ...props }) => {
  return <img src="/assets/icons/exclamation-triangle-fill-red.svg" {...props} />;
};
export const IconCheckCircleFillInfo = ({ ...props }) => {
  return <img src="/assets/icons/check-circle-fill-info.svg" {...props} />;
};
export const IconExclamationCircleWarning = ({ ...props }) => {
  return <img src="/assets/icons/exclamation-circle-warning.svg" {...props} />;
};

export const IconSearch = ({ ...props }) => {
  return <img src="/assets/icons/search.svg" className="filter-red" {...props} />;
};

export const IconGPSLocationCrosshairs = ({ ...props }) => {
  return <img src="/assets/icons/location-crosshairs-solid.svg" {...props} />;
};

export const IconFunnelFilter = ({ ...props }) => {
  return <img src="/assets/icons/funnel-fill.svg" {...props} />;
};

export const IconRefresh = ({ ...props }) => {
  return <img src="/assets/icons/arrow-clockwise.svg" {...props} />;
};

export const IconList = ({ ...props }) => {
  return <img src="/assets/icons/list.svg" {...props} />;
};

export const IconTableColumns = ({ ...props }) => {
  return <img src="/assets/icons/table-columns-solid.svg" {...props} />;
};
